import React, { Component } from 'react';

import moment from 'moment-with-locales-es6';
import { connect} from "remx";
import broker from '../../../utils/broker';
import config from '../../../utils/config';
import dataStore from '../../../stores/data';


class ListFiles extends Component {
    constructor(props) {
        super(props);
    
        this.options = {
          sortIndicator: true,
          hideSizePerPage: true,
          paginationSize: 6,
          hidePageListOnlyOnePage: true,
          clearSearch: true,
          alwaysShowAllBtns: false,
          withFirstAndLast: false
        }
        this.state = {
          reload:false,
          loading: false,
          data : [],
          keterangan : '',
          image_url : '',
        }
      }

      getDataFiles(){
        broker.fetchSupport.get(`data_file_report_2?kategori_id=${this.props.data_klasifikasi.kategori_id}&klasifikasi_id=${this.props.data_klasifikasi.klasifikasi_id}`)
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({data : data})
            } else {

            }
        }).catch(err => {
            
        });
      }



    componentDidMount(){
        if (this.props.data_klasifikasi.kategori_id) {
            this.getDataFiles();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.data_klasifikasi !== prevProps.data_klasifikasi) {
            this.getDataFiles()
        }
    }
      
    render(){
          // console.log(this.state.data)
          return(
            <div className="pd-20 pd-lg-25 pd-xl-30">
              {/* <h4 className="mg-b-15 mg-lg-b-25">All Files</h4> */}
              <label className="d-block tx-medium tx-10 tx-uppercase tx-sans tx-spacing-1 tx-color-03 mg-b-15">Monthly Report {this.props.data_kategori_per.nama_kategori}</label>
                <div className="row row-xs">
                  {(this.state.data) &&
                    this.state.data.map((data, i) => {
                      if (data.tipe_file === 'REPORT') {
                        return <div className="col-sm-2 col-sm-3 col-md-4 file-width mg-b-10" key={i}>
                                <div className="card card-file">
                                  <div className="card-file-thumb tx-danger">
                                    <i className="far fa-file-pdf"></i>
                                  </div>
                                  <div className="card-body">
                                    <h6><a href={config.api_support+'/download_report/'+data.nama_file} className="link-02">{data.nama_file}</a></h6>
                                    <span>{moment(data.periode).locale('id').format('MMMM, YYYY')}</span>
                                  </div>
                                  <div className="card-footer"><span className="d-none d-sm-inline">Created: </span>{moment(data.created_at).format('DD-MM-YYYY')}</div>
                                </div>
                              </div> 
                      }

                    })
                  }  
                </div>
                <hr className="mg-y-40 bd-0" />
                <label className="d-block tx-medium tx-10 tx-uppercase tx-sans tx-spacing-1 tx-color-03 mg-b-15">Recently View Report {this.props.data_kategori_per.nama_kategori}</label>
                <div className="row row-xs">
                  {(this.state.data) &&
                    this.state.data.map((data, i) => {
                      if (data.tipe_file === 'GENERATE') {
                        return <div className="col-sm-6 col-lg-4 col-xl-3 mg-b-10" key={i}>
                                 <div className="media media-folder">
                                  <i className="far fa-3x fa-file-pdf tx-primary"></i>
                                  <div className="media-body">
                                    <h6><a href={config.api_support+'/download_report/'+data.nama_file} className="link-02">{data.nama_file.substring(0, 20) + (data.nama_file.length > 20 ? '.....' : '')}</a></h6>
                                    <span>{moment(data.created_at).format('DD-MM-YYYY')}</span>
                                  </div>
                                </div>
                              </div> 
                      }

                    })
                  }  
                </div>
              </div>
          );
        
    }

}

function mapStateToProps(props) {
    return {
      kategori_id : dataStore.getters.getDataKategoriId(),
      data_kategori_per : dataStore.getters.getDataKategoriPer(),
      data_klasifikasi : dataStore.getters.getDataKlasifikasi()
    }
}


export default connect(mapStateToProps)(ListFiles);